module.exports = require('./lib/server')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/server.js
// module id = 295
// module chunks = 0